import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <section className="bg-paper px-4 py-16 sm:py-24" aria-labelledby="testimonials-title" data-id="element-349" data-mp="3mepjurjhftqe">
      <div className="mx-auto max-w-6xl" data-id="element-350" data-mp="3r8ttjik4ufv6">
        <SectionHeading eyebrow="Feedback about the Blueprint™" title={<span id="testimonials-title" data-id="element-352" data-mp="42t1z924inng">What other nursing professionals say</span>} data-id="element-351" data-mp="1hill9ueynp" />

        <ul className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-353" data-mp="44npmv4s4tv8">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-[0_1px_2px_rgba(6,18,41,0.06)] ring-1 ring-navy-900/5" data-id="element-354" data-mp="e0z5tw7hq3uy">
              <div className="flex items-center justify-between" data-id="element-355" data-mp="2avlt3ti0983h">
                <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-356" data-mp="2fsvorqvzmfzr">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-cta text-cta" aria-hidden="true" data-id="element-357" data-mp="1ntszx29172ru" data-mpi={i} />)}
                </div>
                <QuoteIcon className="h-7 w-7 text-brand/40" aria-hidden="true" data-id="element-358" data-mp="1ivrggg7p11fu" />
              </div>
              <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-ink" data-id="element-359" data-mp="1eu5u8499rasz">“{t.quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-navy-900/10 pt-5" data-id="element-360" data-mp="2bi3vpqzvec99">
                <img src={t.photo} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-brand" loading="lazy" data-id="element-361" data-mp="26lls4uga0jyi" />
                <div data-id="element-362" data-mp="1xlqbwb7v5yrm">
                  <p className="font-extrabold text-ink" data-id="element-363" data-mp="r3k07gw3nr1z">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-364" data-mp="r4v3lflmuwsk">{t.role}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-6 max-w-2xl text-center text-xs leading-relaxed text-muted" data-id="element-365" data-mp="nl4ecfx4j55a">
          Illustrative feedback examples showing the kind of experience readers describe.
        </p>

        <SectionCTA label="I want to explore the Blueprint™" data-id="element-366" data-mp="elhalngx9n92" />
      </div>
    </section>;
}